import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgAviron(props) {
    return (
        <Svg
            width={props.size ?? 20}
            height={props.size ?? 20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M19.65 6.144L17.998 4.49l1.243-1.243a.585.585 0 000-.828L17.576.754a.603.603 0 00-.829 0l-1.243 1.243L13.85.343A1.172 1.172 0 1012.193 2l5.8 5.801a1.172 1.172 0 001.658-1.657zM7.807 18l-5.8-5.801a1.172 1.172 0 00-1.658 1.657l1.654 1.654-1.24 1.24a.585.585 0 000 .829l1.664 1.664a.584.584 0 00.828 0l1.24-1.24 1.655 1.654a1.172 1.172 0 001.657-1.658zM10.535 6.973l-3.557 3.569 2.485 2.486 3.558-3.57-2.486-2.485zM17.994 9.458L10.536 2a1.172 1.172 0 00-1.658 1.658l7.458 7.458a1.172 1.172 0 101.658-1.658zM11.121 16.342L3.664 8.884a1.172 1.172 0 00-1.658 1.657L9.464 18a1.172 1.172 0 001.657-1.657z"
                fill={props.color ?? baseColors.green.primary}
            />
        </Svg>
    )
}

export default SvgAviron
